export default __webpack_public_path__ + "static/media/justpayto-philippines-paymentsolutions.1604cad8.png";